import {Box, HBox} from '@buncha/components/core/view';
import {StyleProp, ViewStyle} from 'react-native';

import BunchaIcon from '@buncha/components/core/icon/BunchaIcon';
import IfElse from '@buncha/components/conditional/IfElse';
import MeijerIcon from '@buncha/components/core/icon/MeijerIcon';
import React from 'react';
import {styles} from './styles';
import {useColorThemeType} from '@buncha/appStyles/hooks/theme';

interface Props {
  leftIcon?: JSX.Element;
  style?: StyleProp<ViewStyle>;
}

const OrderHeader: React.FC<Props> = props => {
  const theme = useColorThemeType();
  const {leftIcon} = props;

  return (
    <Box
      style={[
        styles.mainContainer,
        {
          backgroundColor: theme?.background.blue[500],
        },
        props?.style,
      ]}>
      <HBox>
        <Box>
          <IfElse
            condition={leftIcon}
            ifComponent={leftIcon ?? <></>}
            elseComponent={
              <MeijerIcon width={120} height={80} viewBox="70 -20 300 300" />
            }
          />
        </Box>
        <Box>
          <BunchaIcon height={67} width={210} viewBox="0 -20 80 80" />
        </Box>
      </HBox>
    </Box>
  );
};

export default React.memo(OrderHeader);
